import { StoreName } from "../../decorators/StoreNameDecorator";
import {
  AcceleratorBatch,
  AcceleratorBatchData,
} from "../../models/AcceleratorBatch";
import API from "../../models/API";
import { sortBatches } from "../../models/SweetListSorter";
import { AbstractRemovableStore } from "../RemovableStore";

/**
 * Key is AcceleratorBatch UUID.
 */
@StoreName("AcceleratorBatchStore")
class AcceleratorBatchStoreClass<
  String,
  _ extends AcceleratorBatch,
> extends AbstractRemovableStore<String, AcceleratorBatch> {
  storedObjectKeysEquals(a: String, b: String): boolean {
    return a === b;
  }

  async lookup(uuid: String): Promise<AcceleratorBatch | undefined> {
    return await API.get(`/v0/instance/${uuid}`)
      .then(async (value: Response) => {
        if (!value.ok) {
          return undefined;
        }
        const batchInstance: AcceleratorBatchData =
          (await value.json()) as AcceleratorBatchData;
        if (batchInstance) {
          return new AcceleratorBatch(batchInstance);
        } else {
          return undefined;
        }
      })
      .catch((e) => {
        console.log(e);
        return undefined;
      });
  }

  getAll(): Array<AcceleratorBatch> {
    const returnValues = this.values;
    sortBatches(returnValues);
    // SweetListSorter.sort(returnValues, (data) => data.batchInstanceId, 'BI', 16);
    return returnValues;
  }

  async lookupBatchesByBatchClassId(batchClassId: string): Promise<string[]> {
    return await API.get("/v0/instance", {
      batchClassId,
    })
      .then((value: Response) => value.json())
      .catch((error: string) => {
        console.log(error);
        return [];
      });
  }

  //@ts-expect-error
  _vamp(values) {
    //@ts-expect-error
    this.values = values.map((r) => new AcceleratorBatch(r));
  }
  _unvamp() {
    return this.values;
  }
}

const AcceleratorBatchStore = new AcceleratorBatchStoreClass<
  string,
  AcceleratorBatch
>();

export { AcceleratorBatchStore, AcceleratorBatchStoreClass };
